const SET_ARCHIVED_ACCOUNTS_FILTERS = 'SET_ARCHIVED_ACCOUNTS_FILTERS';
export const setArchivedAccountsFilters = (filters: ArchivedAccountsFilters) => ({
  type: SET_ARCHIVED_ACCOUNTS_FILTERS,
  payload: filters,
});

export interface ArchivedAccountsFilters {
  [key: string]: any;
}

const initialState: ArchivedAccountsFilters = {};

interface Action {
  type: string;
  payload: ArchivedAccountsFilters;
}

export const archivedAccountsFiltersReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_ARCHIVED_ACCOUNTS_FILTERS:
      return { ...action.payload };

    default:
      return state;
  }
};
